import { z } from "zod";
import {
	StaffPasswordPolicyError,
	validateStaffPasswordStrength,
} from "./staff-password-policy";

export function staffPasswordZodRefine(
	value: string,
	ctx: z.RefinementCtx,
): void {
	try {
		validateStaffPasswordStrength(value);
	} catch (error) {
		if (error instanceof StaffPasswordPolicyError) {
			ctx.addIssue({
				code: "custom",
				message: error.message,
			});
			return;
		}
		throw error;
	}
}

export const staffPasswordSchema = z
	.string()
	.superRefine(staffPasswordZodRefine);

export const optionalStaffPasswordSchema = z
	.string()
	.optional()
	.superRefine((value, ctx) => {
		if (!value) return;
		staffPasswordZodRefine(value, ctx);
	});
